class Associations {
  constructor(client) {
    this.client = client
  }

  create(data) {
    return this.client._request({
      method: 'PUT',
      path: '/crm-associations/v1/associations',
      body: data,
    })
  }

  createBatch(data) {
    return this.client._request({
      method: 'PUT',
      path: '/crm-associations/v1/associations/create-batch',
      body: data,
    })
  }

  delete(data) {
    return this.client._request({
      method: 'PUT',
      path: '/crm-associations/v1/associations/delete',
      body: data,
    })
  }

  deleteBatch(data) {
    return this.client._request({
      method: 'PUT',
      path: '/crm-associations/v1/associations/delete-batch',
      body: data,
    })
  }
}

module.exports = Associations



//////////////////
// WEBPACK FOOTER
// ./~/hubspot/lib/crm_association.js
// module id = oX0F
// module chunks = 1